import React from 'react';

const WEEKDAYS = [
  { value: 1, label: 'Montag' },
  { value: 2, label: 'Dienstag' },
  { value: 3, label: 'Mittwoch' },
  { value: 4, label: 'Donnerstag' },
  { value: 5, label: 'Freitag' },
  { value: 6, label: 'Samstag' },
  { value: 0, label: 'Sonntag' },
];

// Liste von Wochentermin-Zeilen (Wochentag + Uhrzeit + Dauer), dynamisch erweiterbar.
function CourseScheduleSlots({ slots, onChange }) {
  const updateSlot = (index, field, value) => {
    const next = slots.map((slot, i) => (i === index ? { ...slot, [field]: value } : slot));
    onChange(next);
  };

  const addSlot = () => {
    onChange([...slots, { weekday: 1, time: '', duration: '1.5' }]);
  };

  const removeSlot = (index) => {
    onChange(slots.filter((_, i) => i !== index));
  };

  return (
    <div>
      <label className="form-label">Wöchentliche Termine</label>
      {slots.map((slot, index) => (
        <div key={index} className="row g-2 mb-2 align-items-end">
          <div className="col-5">
            <select
              className="form-select form-select-sm"
              value={slot.weekday}
              onChange={(e) => updateSlot(index, 'weekday', parseInt(e.target.value, 10))}
            >
              {WEEKDAYS.map((day) => (
                <option key={day.value} value={day.value}>{day.label}</option>
              ))}
            </select>
          </div>
          <div className="col-3">
            <input
              type="time"
              className="form-control form-control-sm"
              value={slot.time}
              onChange={(e) => updateSlot(index, 'time', e.target.value)}
            />
          </div>
          <div className="col-3">
            <input
              type="number"
              className="form-control form-control-sm"
              value={slot.duration}
              onChange={(e) => updateSlot(index, 'duration', e.target.value)}
              min="0.25"
              step="0.25"
              placeholder="Std."
            />
          </div>
          <div className="col-1">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => removeSlot(index)}
              disabled={slots.length <= 1}
              title="Termin entfernen"
            >
              &times;
            </button>
          </div>
        </div>
      ))}
      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={addSlot}>
        + Weiterer Wochentermin
      </button>
    </div>
  );
}

export default CourseScheduleSlots;
